module.exports = __webpack_public_path__ + "img/user (3).08b63b52.png";